import React, {useContext, useState} from 'react';
import {Box, Button, Card, CardContent, Checkbox, FormControlLabel, Grid, Typography} from '@mui/material';
import PetsIcon from '@mui/icons-material/Pets';
import {GlobalStateContext} from '../../state/GlobalStateProvider';
import {useAppointmentsAPI} from '../../service/useAppointmentsAPI';
import {useTranslation} from 'react-i18next';
import {formatDateTimeLocal} from "../../common/DateUtil";

export default function AppointmentOverview({updateCurrentStep}) {
    const {globalState} = useContext(GlobalStateContext);
    const {checkoutAppointment} = useAppointmentsAPI();
    const [termsOfUse, setTermsOfUse] = useState(false);
    const {t} = useTranslation();

    const goBack = () => updateCurrentStep(5);

    const onConfirm = async () => {
        try {
            window.location.href = await checkoutAppointment(globalState.appointment.selectedAppointments, globalState.appointment.notes);
        } catch (e) {
            console.error('Failed to checkout appointment:', e);
        }
    };

    return (
        <Grid container alignItems="center" justifyContent="center" spacing={1} sx={{textAlign: 'center'}}>
            <Grid item xs={12} sm={10} md={8} lg={6}>
                <Card variant="outlined">
                    <CardContent>
                        <Typography variant="h5" component="div" color="secondary" sx={{mb: 1}}>
                            <h1>{t('appointmentOverview')}</h1>
                        </Typography>
                        <Box sx={{textAlign: 'center'}}>
                            {/* If animal available, mirror ReservationOverview pets row */}
                            <Typography color="secondary" display="block">
                                <b>{t('for')}</b>
                            </Typography>
                            {globalState.reservationMeta?.animalsInReservationNames?.map((name, index) => (
                                <Typography key={`animal-${index}`} color="secondary" display="block" sx={{mb: 1}}>
                                    <PetsIcon color="primary"/> {name}
                                </Typography>
                            ))}
                            {globalState.appointment?.selectedAppointments?.map((appointment, index) => (
                                <React.Fragment key={`appointment-${index}`}>
                                    <Typography sx={{mb: 0.5}} color="secondary" display="block">
                                        <b>{t('service')}</b> {appointment.serviceName || '-'}
                                    </Typography>
                                    <Typography sx={{mb: 0.5}} color="secondary" display="block">
                                        <b>{t('start')}</b> {formatDateTimeLocal(appointment.startAt) || '-'}
                                    </Typography>
                                    <Typography sx={{mb: 0.5}} color="secondary" display="block">
                                        <b>{t('end')}</b> {formatDateTimeLocal(appointment.endAt) || '-'}
                                    </Typography>
                                </React.Fragment>
                            ))}
                            <Typography sx={{mb: 0.5}} color="secondary" display="block">
                                {/*TODO price and advance should be calculated by backService*/}
                                <b>{t('price')}</b> {(globalState?.appointment?.price) * globalState?.appointment?.selectedAppointments?.length  || '-'}
                            </Typography>
                            <Typography sx={{mb: 0.5}} color="secondary" display="block">
                                <b>{t('advance')}</b> {(globalState?.appointment?.price / 2) * globalState?.appointment?.selectedAppointments?.length || '-'}
                            </Typography>
                            <Typography sx={{mb: 0.5}} color="secondary" display="block">
                                <b>{t('notes')}</b> {globalState?.appointment.notes || '-'}
                            </Typography>
                            <Box sx={{mt: 2, display: 'flex', justifyContent: 'center'}}>
                                <FormControlLabel
                                    control={<Checkbox color="primary" checked={termsOfUse} onChange={(e) => setTermsOfUse(e.target.checked)} inputProps={{ "data-testid": "terms-of-use-checkbox" }}/>}
                                    label={t('termsAgreementLabel')}
                                />
                            </Box>
                        </Box>
                        <Box sx={{mt: 3, display: 'flex', justifyContent: 'space-between'}}>
                            <Button variant="outlined" onClick={goBack} data-testid="previous-button">{t('previous')}</Button>
                            <Button variant="contained" onClick={onConfirm} disabled={!termsOfUse} data-testid="confirm-appointment-button">{t('confirmAppointment')}</Button>
                        </Box>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
}
